<template>
  <!-- Vue2组件模板：移除html/head/body根标签，保留核心登录界面结构 -->
  <div class="p-login-page">
    <div class="m-login-body">
      <div id="ts-particles" class="m-particle-bg">
        <canvas class="particles-js-canvas-el" width="692" height="905" style="width: 100%; height: 100%;"></canvas>
      </div>
      <div class="m-login-bd-top">
        <p class="c-title-content">交通运输行业智能安全生产管理系统</p>
      </div>
      <div class="m-login-bd-content">
        <div class="m-login-bd-left"></div>
        <div class="m-login-bd-right">
          <div class="m-login-box">
            <div class="m-login-bd-header">欢迎登录安全台账</div>
            <!-- Element UI表单 - Vue2绑定方式 -->
            <!-- 添加 ref 和 :model 绑定 -->
            <el-form 
              ref="ruleForm"
              :model="ruleForm" 
              class="el-form m-login-bd-form el-form--label-left" 
              autocomplete="on"
            >
              <!-- 账号输入框：图片图标（用户） -->
              <el-form-item>
                <div class="el-form-item__content" style="margin-left: 0px;">
                  <el-input 
                    v-model="ruleForm.account" 
                    placeholder="请输入帐号/身份证号/手机号码" 
                    class="el-input--prefix el-input--suffix"
                  >
                    <!-- Vue2中自定义前缀图标（图片替代SVG） -->
                    <template slot="prefix">
                      <img 
                        src="https://cdn.icon-icons.com/icons2/1826/PNG/512/4202090-avatar-human-man-person-user_116369.png" 
                        style="width:24px; height:24px;"
                      >
                    </template>
                  </el-input>
                </div>
              </el-form-item>
              <!-- 密码输入框：图片图标（锁） -->
              <!-- 注意：这里应该使用 checkPass 而不是 password，保持代码一致性 -->
              <el-form-item>
                <div class="el-form-item__content" style="margin-left: 0px;">
                  <el-input 
                    v-model="ruleForm.checkPass" 
                    type="password" 
                    placeholder="请输入密码" 
                    class="el-input--prefix el-input--suffix"
                  >
                    <template slot="prefix">
                      <img 
                        src="https://cdn.icon-icons.com/icons2/1826/PNG/512/4202097-lock-locked-padlock-password-security_116368.png" 
                        style="width:24px; height:24px;"
                      >
                    </template>
                    <template slot="suffix">
                      <span class="el-input__suffix-inner"></span>
                    </template>
                  </el-input>
                </div>
              </el-form-item>
              <el-form-item class="c-login-btn-item">
                <div class="el-form-item__content" style="margin-left: 0px;">
                  <el-button 
                    type="primary" 
                    @click="SubmitFunc"
                  >
                    登录
                  </el-button>
                  <!-- <div class="c-login-protocol">
                    <el-checkbox v-model="protocolChecked" label="我已阅读并同意平台《隐私政策》"></el-checkbox>
                  </div> -->
                </div>
              </el-form-item> 
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/css/loginysw_new.css";
import IndexApi from "@/api/index.js";
import { yzm } from '@/assets/js/yzm';
import UserApi from "@/api/user.js";
import { setCookie, delCookie } from "@/utils/base.js";
export default {
  data() {
    return {
      ruleForm: {
        account: '',
        checkPass: ''  // 统一使用 checkPass 而不是 password
      },
      // protocolChecked: false,
      showLoginDialog: false,
      loading: false,
      logining: false,  // 添加 logining 状态
      pathroute: "",
      icp: '',
      rules: {
        account: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        checkPass: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
    };
  },
  mounted() {
    // 如果 yzm 是函数，调用它
    if (typeof yzm === 'function') {
      yzm(1);
    }
  },
  created() {
    delCookie('token');
    this.getData();
    // 注意：这里使用的是 checkPass，但环境变量是 NODE_PASS
    if (process.env.NODE_ENV !== 'production') {
      this.ruleForm.account = process.env.NODE_USER || '';
      this.ruleForm.checkPass = process.env.NODE_PASS || '';
    }
  },
  methods: {
    getYzm() {
      if (typeof yzm === 'function') {
        yzm();
      }
    },
    /*获取基础配置*/
    getData() {
      let self = this;
      IndexApi.base({})
        .then((res) => {
          console.log(res)
          if(res.data.config.icp != ''){
            self.icp = res.data.config.icp;
          }
          if(res.data.config.kmd_support=="w7"){
            window.location.href = window.location.protocol + '//' + window.location.host;
          }
        })
        .catch((error) => {
          self.loading = false;
        });

    },

    /*登录方法*/
    SubmitFunc() {
      // 检查是否同意协议
      // if (!this.protocolChecked) {
      //   this.$message.error('请先阅读并同意隐私政策');
      //   return;
      // }

      // 添加表单验证
      if (!this.ruleForm.account) {
        this.$message.error('请输入用户名');
        return;
      }
      if (!this.ruleForm.checkPass) {
        this.$message.error('请输入密码');
        return;
      }

      this.logining = true;
      var Params = {
        username: this.ruleForm.account,
        password: this.ruleForm.checkPass,  // 注意这里也使用 checkPass
      };
      
      /*调用登录接口*/
      UserApi.login(Params, true)
        .then((res) => {
          console.log(res);
          this.logining = false;
          if (res.code == 1) {
            /*保存个人信息*/
            setCookie("userinfo", JSON.stringify(res.data));
            if(res.data.supply){
              setCookie("is_supply", 1);
            }else{
              setCookie("is_supply", 0);
            }
            if(res.data.token != undefined){
              setCookie("token", res.data.token);
            }
            /*设置一个登录状态*/
            setCookie("isLogin", true);
            this.pathroute = res.data.path;
            console.log(this.pathroute);
            /*跳转到首页*/
            if (this.pathroute != "") {
              this.$router.push({ path: this.pathroute });
            } else {
              this.$router.push({ path: "/" });
            }
          } else {
            this.$message({
              message: res.message || "登录失败",
              type: "error",
            });
          }
        })
        .catch((error) => {
          //接口调用方法统一处理
          this.logining = false;
          this.$message.error('登录请求失败');
        });
    },
  },
};
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/views/login.vue